import React from "react";
import { PageSeo } from "../components/PageSeo";
import { LodgingSection } from "../components/LodgingSection";

export function SmestajPage() {
  return (
    <>
      <PageSeo
        title="Prenoćište Kragujevac | Smeštaj | RESTORAN KRČMA"
        description="Prenoćište RESTORANA KRČMA u Kragujevcu: udoban smeštaj sa dvokrevetnim i trokrevetnim sobama."
        keywords="prenoćište Kragujevac, smeštaj Kragujevac, noćenje Kragujevac"
        path="/smestaj"
      />
      <LodgingSection />
    </>
  );
}

